document.addEventListener('DOMContentLoaded', function () {
  var toggleDiv = document.querySelector('.toggle-div');
  var moreInfo = document.querySelector('.more-info');

  toggleDiv.addEventListener('click', function () {
    if (moreInfo.style.display === 'none' || moreInfo.style.display === '') {
      moreInfo.style.display = 'block';
      toggleDiv.textContent = 'Read Less';
    } else {
      moreInfo.style.display = 'none';
      toggleDiv.textContent = 'Read More';
    }
  });
});
